// extracted by mini-css-extract-plugin
export default {"exampleslist":"styles_exampleslist__RX2il"};